import { render, staticRenderFns } from "./games.vue?vue&type=template&id=3ad383d0&scoped=true"
import script from "./games.vue?vue&type=script&lang=js"
export * from "./games.vue?vue&type=script&lang=js"
import style0 from "./games.vue?vue&type=style&index=0&id=3ad383d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad383d0",
  null
  
)

export default component.exports